import { RevisaoTransferenciaTipoView } from "./view-revisao-transferencia-tipo";
import type { RevisaoTransferenciaTipoProps } from "./types-revisao-transferencia-tipo";

export function RevisaoTransferenciaTipo(props: RevisaoTransferenciaTipoProps) {
  return <RevisaoTransferenciaTipoView {...props} />;
}

export type * from "./types-revisao-transferencia-tipo";
